// Text in the three languages of the help centre and the lessons (Greek, English, Russian).
export type Lang3 = 'el' | 'en' | 'ru';
export const LANGS3: readonly Lang3[] = ['el', 'en', 'ru'];
export type L3 = Record<Lang3, string>;
export const T3 = (el: string, en: string, ru: string): L3 => ({ el, en, ru });
/** the help language for an interface locale: Greek, Russian, otherwise English */
export const lang3 = (locale: string): Lang3 => (locale.startsWith('el') ? 'el' : locale.startsWith('ru') ? 'ru' : 'en');
